import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { toneEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import { DiscountType } from '@/features/dashboard/discounts/types/DiscountType.ts';
import { Percent, BadgeDollarSign } from 'lucide-react';

export const discountTypeTableConfig: EnumTableConfig = {
  [DiscountType.PERCENTAGE]: {
    ...toneEnumConfig('Procentowy', 'info', Percent),
    tooltip: 'Rabat procentowy',
    displayMode: 'icon',
  },
  [DiscountType.FIXED_AMOUNT]: {
    ...toneEnumConfig('Kwotowy', 'info', BadgeDollarSign),
    tooltip: 'Rabat kwotowy',
    displayMode: 'icon',
  },
};
